(function($) {

	'use strict';

	var init = function() {
		$('.archive-filter__select').on('change', function(){
			$('.archive-filter__form').submit();
		});
		$('.archive-filter__form').submit(function(e){
			var has_values = false;
			$(this).find(':input').each(function(i){
				if(!$(this).val()){
					$(this).attr('name', '');
				} else {
					has_values = true;
				}
			});
			if(!has_values){
				e.preventDefault();
				window.location = $(this).attr('action');
			}
		});
    }

	$(document).ready(function() {
		if( $('body').hasClass('page-template-template-archive') || $('body').hasClass('blog') || $('body').hasClass('page-template-default') ){
			init();
		}
	});

})(jQuery);